/**
 * Reads the host's runtime config, client-config.json beside the page.
 *
 * When Gaia's web-service serves this build at /client/, it also serves
 * /client/client-config.json naming the gateway for that host, so one build
 * runs on any host. Anywhere else (the Vite dev server, a plain static host)
 * there is no such file and the build-time gateway stays in use. A host that
 * never answers is given up on after timeoutMs, so the page still renders.
 */
export async function loadGatewayBaseUrl(
  fetchImpl: typeof fetch = fetch,
  base: string = import.meta.env.BASE_URL,
  timeoutMs = 3000
): Promise<string | null> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetchImpl(`${base}client-config.json`, { cache: 'no-store', signal: controller.signal });
    if (!response.ok) return null;
    const config: unknown = await response.json();
    const gateway = (config as { gateway_http?: unknown } | null)?.gateway_http;
    return typeof gateway === 'string' && gateway.trim() ? gateway.trim() : null;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
